import { styled, Switch, Box } from '@mui/material'
import theme from 'lib/theme'

export const BlueSwitch = styled(Switch)(({ theme }) => ({
  width: '42px',
  height: '26px',
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: theme.palette.commonColors.white,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        backgroundColor: theme.palette.commonColors.white,
        border: `1px solid ${theme.palette.action.disabled}`,
      },
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    border: `1px solid ${theme.palette.icon.main}`,
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.commonColors.white,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))

export const SidebarLinkWrapper = styled(Box, {
  shouldForwardProp: (props) => props !== 'optionKey' && props !== 'location',
})<{ optionKey: string; location: string }>(({ optionKey, location }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '100%',
  textAlign: 'left',
  height: '32px',
  borderRadius: '2px',
  marginTop: theme.spacing(1),
  marginRight: 0,
  marginLeft: 0,
  backgroundColor:
    optionKey.toLowerCase() === location
      ? theme.palette.action.selected
      : 'transparent',
  color:
    optionKey.toLowerCase() === location
      ? theme.palette.primary.main
      : theme.palette.commonColors.black,
  '&:hover': {
    cursor: optionKey.toLowerCase() === location ? 'auto' : 'pointer',
    backgroundColor:
      optionKey.toLowerCase() === location
        ? theme.palette.action.selected
        : theme.palette.action.hover,
  },
}))
